const languages = [
  { language: "English", lang_code: "en" }
];

export default languages;